function debounce(func, wait) {
    let timeout;
    return function() {
        let later = () => {
            timeout = null;
            func.apply(this, arguments);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

export default debounce;


// WEBPACK FOOTER //
// ./src/components/SearchContent/debounce.js